<template>
    <div class="buildings-map-filters__wrap">
    <form class="buildings-map-filters">
        <div class="form-group">
            <multiselect
                    v-model="form.type"
                    :options="types"
                    placeholder="Вид объекта"
                    :multiple="false"
                    selectLabel=""
                    :disabled = filtersDisabled
                    selectedLabel="Выбрано"
                    deselectLabel="Удалить"
            ></multiselect>
        </div>
        <div class="form-group">
            <multiselect
                v-model="form.rooms"
                :options="rooms"
                placeholder="Кол-во комнат"
                :multiple="true"
                selectLabel=""
                :disabled = filtersDisabled
                selectedLabel="Выбрано"
                deselectLabel="Удалить"
            ></multiselect>
        </div>
        <div class="form-group">
            <multiselect v-model="form.floor"
                         :options="floors"
                         placeholder="Этаж"
                         :disabled = filtersDisabled
                         :multiple="true"
                         selectLabel=""
                         selectedLabel="Выбрано"
                         deselectLabel="Удалить"
            ></multiselect>
        </div>
        <div class="form-group">
            <multiselect
                v-model="form.districts"
                :options="districts"
                :disabled = filtersDisabled
                placeholder="Район"
                selectLabel=""
                :multiple="true"
                selectedLabel="Выбрано"
                deselectLabel="Удалить"
            ></multiselect>
        </div>
        <div class="form-group d-flex align-items-center">
            <div>
                <input  v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.square_from" class="buildings-map-filters__input form-control" placeholder="Площадь от (м2)">
            </div>
            <span class="mr-1 ml-1">—</span>
            <div>
                <input v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.square_to" class="buildings-map-filters__input form-control" placeholder="до (м2)">
            </div>
        </div>
        <div class="form-group d-flex align-items-center" style="max-width: 100%">
            <div>
                <input v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.apartment_price_from" class="buildings-map-filters__input form-control" placeholder="Цена от (руб.)" >
            </div>

            <span class="mr-1 ml-1">—</span>
            <div>
                <input v-bind:disabled="filtersDisabled" @input="isTyping = true"  type="text" v-model="form.apartment_price_to" class="buildings-map-filters__input form-control" placeholder="до (руб.)">
            </div>

        </div>
        <button class="btn button-link" @click.prevent="clearFilter"  v-if="filtered" v-bind:disabled="filtersDisabled">
            <span class="button-link__text">Сбросить все фильтры</span>
            <i class="fas fa-times"></i>
        </button>

    </form>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    export default {
        components:{
            Multiselect,
        },
        props:['options','filtersDisabled'],
        computed: {
            searchQuery() {
                return this.form.name;
            }
        },
        data() {
            return {
                statuses: [],
                isTyping: false,
                form: {
                    name:'',
                    type:'',
                    statuses:[],
                    rooms:[],
                    year:[],
                    districts:[],
                    square_from:'',
                    square_to:"",
                    apartment_price_from:'',
                    apartment_price_to:'',
                    floor:'',

                },
                filtered:false,
                floors: [1,2,3,4,5,6,7,8,9,10,11,12],
                districts: [
                    'Центр',
                    'Кузнец Затон',
                    'Зелёная роща',
                    'Сипайлово',
                    'Черниковка',
                    'Дёма',
                    'Шакша',
                    'Пр. Октября',
                    'Глумилино',
                    'Планета',
                    'Инорс',
                    'Затон',
                    'Аэропорт',
                    'За чертой города'
                ],
                years: [
                    2020,
                    2021,
                    2022,
                    2023,
                ],
                types:['Вторичка', 'От застройщика'],
                status_list: [
                    {
                        value:'not_specified',
                        label:'Динамика не указана',
                        color:'#C4C4C4'
                    },
                    {
                        value:'part_passed',
                        label:'Частично сдан',
                        color:'#0066CC'
                    },
                    {
                        value:'progress',
                        label:'Ведется строительство',
                        color:'#339900'
                    },
                    {
                        value:'passed',
                        label:'ЖК сдан',
                        color:'#1a2055'
                    },
                    {
                        value:'frozen',
                        label:'Заморожен',
                        color:'#fdc20B'
                    },
                    {
                        value:'problem',
                        label:'Проблемный объект',
                        color:'#e61e44'
                    },
                ],
                rooms:[
                    1, 2, 3, 4, 5
                ],
            }
        },
        methods: {
            AddStatus(selectedOption){
                this.form.statuses.push(selectedOption.value);

                console.log(this.form.statuses)
            },
            RemoveStatus(selectedOption){
                let index = this.form.statuses.indexOf(selectedOption.value);
                if(index >= 0) {
                    this.form.statuses.splice(index,1);
                }
                console.log(this.form.statuses)
            },
            filterSubmit() {
                console.log(this.form);
                //this.$emit('filterSubmit',this.form);

            },
            clearFilter() {
                this.statuses = [];
                for (var key in this.form) {
                    if(Array.isArray(this.form[key])) {
                        this.form[key] = [];
                    } else {
                        this.form[key] = '';
                    }

                }
                this.filtered = false;
                this.$emit('clearFilter');
            },
        },
        created:function() {
            //this.debouncedFilterSubmit = _.debounce(this.filterSubmit, 500);
        },
        watch: {
           form: {
               deep: true,
                   handler () {
                   var status = false;
                       for (var key in this.form) {
                           if(this.form[key]) {
                               if(Array.isArray(this.form[key])) {
                                   if(this.form[key].length > 0) {
                                       status =true;
                                   }
                               } else  {
                                   status =true;
                               }
                           }
                       }
                       if(status) {
                               this.filtered = true;
                           if(!this.isTyping){
                               this.filterSubmit()
                           }

                       } else  {
                           this.filtered = false;
                           if(!this.isTyping){
                               this.filterSubmit()
                           }
                       }

               }
            },
            searchQuery:_ .debounce(function() {
         this.isTyping = false;
    }, 800),
            isTyping: function(value) {
                if (!value) {
                    this.filterSubmit()
                }
            }
        },
        mounted() {
            for (var key in this.form) {
                if(this.options[key]) {
                    this.form[key] = this.options[key]
                }
            }
        }
    }
</script>
